var _ellipse, _path, _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _rect8, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 258,
    viewBox: "0 0 516 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.5,
    cy: 228.5,
    rx: 110.5,
    ry: 29.5,
    fill: "url(#paint0_linear_7647_640929)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.449 159.241C178.536 150.798 184.807 142 193.738 142H253L249 213H218.533C207.442 213 197.572 205.965 193.955 195.481L181.449 159.241Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 109.974,
    width: 58.9203,
    height: 73.6504,
    rx: 9,
    transform: "rotate(-28.3442 178 109.974)",
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40.168,
    height: 5.99781,
    rx: 2,
    transform: "matrix(0.876342 -0.48169 0.522607 0.852574 191.223 113.422)",
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7647_640929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.5 112.5L247.5 115L251 117L239.5 137.5L233.5 134L245.5 112.5Z",
    fill: "#EFEEEE"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25.1307,
    height: 5.99781,
    rx: 2,
    transform: "matrix(0.876342 -0.48169 0.522607 0.852574 197.883 124.99)",
    fill: "#EEEEEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 263.797,
    y: 75,
    width: 69.209,
    height: 86.5113,
    rx: 9,
    transform: "rotate(22.2778 263.797 75)",
    fill: "#F9F9F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 50.3057,
    height: 5.99781,
    rx: 2,
    transform: "matrix(0.9159 0.401406 -0.357628 0.933864 266.838 91.1074)",
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7011,
    height: 5.99781,
    rx: 2,
    transform: "matrix(0.9159 0.401406 -0.357628 0.933864 261.262 105.671)",
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 27.3694,
    height: 5.99781,
    rx: 2,
    transform: "matrix(0.9159 0.401406 -0.357628 0.933864 256.145 118)",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.725 112.124L283.839 112.252C285.743 114.384 289.157 114.104 290.689 111.69L291.448 123.878L284.483 124.312L283.725 112.124Z",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305.584 119.097L305.53 119.259C304.636 121.975 306.585 124.792 309.442 124.912L299.266 131.662L295.408 125.848L305.584 119.097Z",
    fill: "#E2E2E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 288.436,
    y: 126.156,
    width: 8.28627,
    height: 13.9558,
    rx: 3,
    transform: "rotate(26.4379 288.436 126.156)",
    fill: "#E2E2E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.587 128.687L289.796 123.423L290.656 123.293L291.448 128.558L290.587 128.687Z",
    fill: "#E2E2E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.824 126.918L292.149 129.463L291.732 128.699L296.408 126.153L296.824 126.918Z",
    fill: "#E2E2E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197 130C197 125.029 201.029 121 206 121H225.589C228.371 121 230.998 122.287 232.702 124.487L242.798 137.513C244.502 139.713 247.129 141 249.911 141H310C314.971 141 319 145.029 319 150V204C319 208.971 314.971 213 310 213H206C201.029 213 197 208.971 197 204V130Z",
    fill: "url(#paint1_linear_7647_640929)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.667 92.5C327.667 93.9728 326.473 95.1667 325 95.1667C323.527 95.1667 322.333 93.9728 322.333 92.5C322.333 91.0272 323.527 89.8333 325 89.8333C326.473 89.8333 327.667 91.0272 327.667 92.5ZM377 55.4997L377.456 55.2949L377 55.4997ZM402 70L402.191 70.4621L402 70ZM325.145 92.0216C329.291 93.2816 335.35 93.3417 341.95 92.2658C348.538 91.1918 355.611 88.9944 361.767 85.7896C367.929 82.5817 373.129 78.3867 376.033 73.3409C378.921 68.3213 379.56 62.4229 376.544 55.7045L377.456 55.2949C380.603 62.3041 379.949 68.5405 376.9 73.8397C373.865 79.1127 368.483 83.4206 362.229 86.6766C355.968 89.9358 348.792 92.1636 342.111 93.2528C335.441 94.3402 329.209 94.3017 324.855 92.9784L325.145 92.0216ZM376.544 55.7045C375.18 52.6675 373.87 51.004 372.759 50.2884C372.214 49.9375 371.737 49.827 371.328 49.8661C370.919 49.9051 370.521 50.0993 370.143 50.4621C369.372 51.2029 368.747 52.5936 368.44 54.414C368.137 56.2179 368.158 58.378 368.615 60.5862C369.528 65.0021 372.167 69.5462 377.344 71.8478C382.529 74.1533 390.376 74.2603 401.809 69.5379L402.191 70.4621C390.624 75.2397 382.471 75.2217 376.937 72.7616C371.395 70.2975 368.597 65.4354 367.635 60.7888C367.155 58.4657 367.129 56.1805 367.454 54.248C367.777 52.332 368.457 50.6953 369.451 49.7408C369.956 49.2558 370.555 48.9353 371.233 48.8706C371.911 48.8059 372.609 49.0026 373.3 49.4475C374.661 50.3236 376.07 52.2069 377.456 55.2949L376.544 55.7045ZM401.809 69.5379C438.567 54.3554 462.887 38.2481 477.675 25.6198L478.325 26.3802C463.447 39.085 439.033 55.2446 402.191 70.4621L401.809 69.5379Z",
    fill: "#EFEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M515.785 0.215332L466.5 10.3305L476.185 17.2175L515.785 0.215332Z",
    fill: "#F5F4F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.969 17.2175L515.354 0.215332L477.906 27.3327L475.969 17.2175Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M516 0L480.059 19.1543L494.048 27.763L516 0Z",
    fill: "#F5F4F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M477.907 27.1171L480.49 19.1541L485.225 21.9519L477.907 27.1171Z",
    fill: "#C1C1C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7647_640929",
    x: 229.5,
    y: 108.5,
    width: 25.5,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7647_640929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7647_640929",
    x1: 255.5,
    y1: 199,
    x2: 255.753,
    y2: 247.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509154,
    stopColor: "#FCFCFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7647_640929",
    x1: 258,
    y1: 145.5,
    x2: 258,
    y2: 213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlaceholder);
export default __webpack_public_path__ + "static/media/empty_placeholder.078e826ca572f11b7fe8eae43b519c24.svg";
export { ForwardRef as ReactComponent };